import { Injectable } from "@angular/core";

import { CommonState } from "../../state";
import { BalanceLimitState } from "../balance-limit/balance-limit.model";

@Injectable({
	providedIn: "root",
})
export class BalanceLimitSelector {
	getBalanceLimit() {
		return (state: CommonState): BalanceLimitState | undefined => state.balanceLimit;
	}
}
